/**
 * pack-galeria.js
 * Cambia la imagen del modelo según el color que el cliente toca en la matriz.
 * Sin foto para ese color, dibuja un swatch grande en vez de dejar el hueco.
 */

class PackGaleria extends HTMLElement {
  connectedCallback() {
    this.fotos = JSON.parse(this.dataset.fotos || '{}');
    this.hex = JSON.parse(this.dataset.hex || '{}');
    this.principal = this.dataset.principal;
    this.producto = this.dataset.producto;

    this.foto = this.querySelector('[data-galeria-foto]');
    this.swatch = this.querySelector('[data-galeria-swatch]');
    this.color = this.querySelector('[data-galeria-color]');
    this.nombre = this.querySelector('[data-galeria-nombre]');
    this.altPrincipal = this.foto ? this.foto.alt : '';

    document.addEventListener('pack:color', (e) => {
      if (String(e.detail.producto) !== String(this.producto)) return;
      this.mostrar(e.detail.color);
    });
  }

  mostrar(color) {
    // Sin color (promo surtida): vuelve a la foto principal.
    if (!color) {
      if (this.foto && this.principal) {
        this.foto.src = this.principal;
        this.foto.alt = this.altPrincipal;
        this.foto.hidden = false;
        this.swatch.hidden = true;
      }
      return;
    }

    const url = this.fotos[color];

    if (url) {
      this.foto.src = url;
      this.foto.alt = color;
      this.foto.hidden = false;
      this.swatch.hidden = true;
      return;
    }

    // Sin foto de ese color: swatch grande, honesto y limpio.
    this.color.style.background = this.hex[color] || '#cccccc';
    this.nombre.textContent = color;
    this.swatch.hidden = false;
    if (this.foto) this.foto.hidden = true;
  }
}

if (!customElements.get('pack-galeria')) {
  customElements.define('pack-galeria', PackGaleria);
}
